import { TextField } from '@mui/material'

export const textFieldDefaults = {
	fullWidth: true,
	variant: 'filled'
}

export const textFieldSelectDefaults = {
	...textFieldDefaults,
	select: true
}

export const numericFormatInputProps = {
	min: 0,
	style: { textAlign: 'right' }
}

export const numericFormatInputDefaults = {
	customInput: TextField,
	slotProps: {
		htmlInput: { ...numericFormatInputProps }
	}
}

export const numericFormatDigitDefaults = {
	decimalScale: 2
}

export const numericFormatDefaults = {
	...textFieldDefaults,
	...numericFormatDigitDefaults,
	...numericFormatInputDefaults
}

export const formControlDefaults = {
	sx: { width: '100%' }
}

export const dialogueContextTextDefaults = {
	component: 'div',
	variant: 'body',
	sx: { color: 'text.main', paddingBottom: 4 }
}

export const paperDefaultProps = {
	variant: "outlined",
	sx: {
		marginBottom: 1,
		border: '1px solid',
		borderRadius: '12px',
		borderColor: '#E8EBEC',
		p: 2
	}
}